export default __webpack_public_path__ + "static/media/calendar-lightGrey.e10f0cfc.svg";